import { render } from "./ZIndexPage.vue?vue&type=template&id=609b7527&ts=true"
import script from "./ZIndexPage.vue?vue&type=script&lang=ts"
export * from "./ZIndexPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__